import React from 'react'
import styles from './styles.css'
import { Form, Field } from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import fileUpload from 'App/helpers/fields/fileUpload'
import AnnexedsTable from './AnnexedsTable'
import FaPaperclip from 'react-icons/lib/fa/paperclip'
import isAdmin from 'App/Decorators/isAdmin'

@isAdmin
@withMutation(gql`
  mutation addAnnexedDocument(
    $documentId: ID
    $attachedDoc: DocumentAttachedInput
    $organizationId: ID
  ) {
    addAnnexedDocument(
      documentId: $documentId
      attachedDoc: $attachedDoc
      organizationId: $organizationId
    ) {
      success
    }
  }
`)
@withMessage
export default class AnnexedDocuments extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    document: PropTypes.object,
    addAnnexedDocument: PropTypes.func,
    onReady: PropTypes.func,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  static fragment = gql`
    fragment documentAnnexeds on Document {
      attachedDoc {
        name
        attach {
          url
        }
      }
    }
  `
  state = {}

  @autobind
  async save() {
    this.setState({ loading: true })
    const attachedDoc = { name: this.state.name, attach: this.state.image }
    try {
      await this.props.addAnnexedDocument(
        {
          documentId: this.props.document._id,
          attachedDoc,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
      this.setState({ name: '', image: null })
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  formAppear() {
    if (!this.props.document.filledBy) {
      return true
    }
    return false
  }

  renderForm() {
    if (this.props.document.filledBy || this.props.document.rejected) return
    return (
      <div>
        <div className="row start-xs">
          <div className="col-xs-12 col-sm-6">
            <Field
              fieldName="name"
              label="name"
              placeholder="Nombre documento"
              type={Text}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Field fieldName="image" label="File" {...fileUpload} />
          </div>
        </div>
        <br />
        <Button primary loading={this.state.loading} onClick={this.save}>
          Guardar
        </Button>
      </div>
    )
  }

  renderAdjuntosFaltantes(){
      let adjuntosFaltantes = "";
      if(this.props.document.attachedDoc){
        for(const attachedRequired of  this.props.document.attachedDoc){
          if(attachedRequired.attach)
            continue
          if(adjuntosFaltantes==="")
            adjuntosFaltantes += attachedRequired.name + " "
          else
            adjuntosFaltantes += ", " + attachedRequired.name + " "
        }
        if(adjuntosFaltantes.length > 0)
          return(
            <div className="content">
              <div className="row">
                <div className="col-xs-12 col-sm-12">
                  <h3 className={styles.error}>Adjuntos requeridos: {adjuntosFaltantes}</h3>
                </div>
              </div>
            </div>
          )
      }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-3">
                <h3 className={styles.title}>Documentos adjuntos</h3>
              </div>
              <div className="col-xs-12 col-sm-9 end-md">
                <div className={styles.icon}>
                  <FaPaperclip size={20} />
                </div>
              </div>
            </div>
          </div>
          {this.renderAdjuntosFaltantes()}
          
          <Form
            ref={form => {
              this.form = form
            }}
            state={this.state}
            onChange={changes => this.setState(changes)}
          >
            <div className="content">
              <AnnexedsTable
                files={this.props.document.attachedDoc}
                document={this.props.document}
              />
              {this.formAppear() ? this.renderForm() : null}
            </div>
          </Form>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/AnnexedDocuments/index.js